import axios from "axios";

const URL = 'https://isolution.dev.br:8084/app';
//const URL = 'http://localhost:8084/app';

const api = axios.create({
    baseURL: URL
});

export default api;